import { Component } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { VaultService } from '../../services/vault.service';
import { NzNotificationService } from 'ng-zorro-antd/notification';
import { RelayService } from '../../services/relay.service';
import { ButtonComponent } from '../../utilities/button/button.component';
import { DropdownComponent } from '../../utilities/dropdown/dropdown.component';
import { InputComponent } from '../../utilities/input/input.component';
import { SelectComponent } from '../../utilities/select/select.component';
import { DashboardComponent } from '../dashboard/dashboard.component';
import { CommonModule } from '@angular/common';
import { GeneralService } from '../../services/general.service';

@Component({
  selector: 'app-edit-relay',
  standalone: true,
  imports: [
    ButtonComponent,
    DropdownComponent,
    InputComponent,
    SelectComponent,
    DashboardComponent,
    CommonModule,
  ],
  templateUrl: './edit-relay.component.html',
  styleUrl: './edit-relay.component.scss',
})
export class EditRelayComponent {
  relayId: string = '';
  fetchingData: boolean = false;
  pageLoader: boolean = false;
  vaults: any[] = [];
  // singleRelay: any = {};
  vaultNames: any;
  loading: boolean = false;
  relayType: string = '';
  filterType: any = ['REQUEST', 'RESPONSE'];
  actionType: any = ['ENCRYPT', 'DECRYPT'];
  conditions: any = ['AND', 'OR'];
  targets: any = ['body', 'headers', 'query'];
  storageType: any = ['EPHEMERAL', 'PERSISTENT'];
  transformers: any = ['Json', 'XML'];
  rulesField: any = ['Status', 'HTTPMethod', 'ContentType', 'PathInfo'];
  selectedRuleDropdown: any;
  fieldPlaceholders: any = {
    Json: 'eg.. $.account_number',
    XML: 'eg.. /account-number',
    RegExp: 'eg.. ^[0-9]{7,14}$',
    Form: 'eg.. account-number',
    HTML: 'eg.. .account-number',
    PDF: '',
  };
  contentTypeData: any = [
    'application/x-www-form-urlencoded',
    'multipart/form-data',
    'application/xml',
    'text/xml',
    'application/json',
    'application/vnd.api+json',
    'text/javascript',
    'application/xhtml-xml',
    'text/html',
  ];
  selectedFieldPraceholder: string = 'eg.. $.account_number';
  httpMethodData: any = [
    'GET',
    'HEAD',
    'POST',
    'PUT',
    'DELETE',
    'CONNECT',
    'OPTIONS',
    'TRACE',
    'PATCH',
  ];
  tokenGenerator: any = [
    'Account Number - Numeric Length Preserving (A4) - xxxxxxxxxxxx<last_four>',
    'Generic - VGS Alias (Default) - tok_sandbox_xxxxxxxxxxxxxxxxxxxxxxxxx',
    'Generic - Numeric Length Preserving - xxxxxxxxxxxxxxxx',
    'Payment Card - Format Preserving - Non Luhn Valid - xxxxxxxxxxxxxxxx',
  ];
  rulesOperator: any = [
    'equals',
    'does_not_equal',
    'begins_with',
    'does_not_begin_with',
    'matches',
    'ends_with',
    'does_not_end_with',
    'is_empty',
    'is_not_empty',
    'does_not_contain',
  ];
  singleRelay: any = {
    name: '',
    type: '',
    vaultId: '',
    sourceIp: [],
    destinationDomain: '',
    filters: [
      {
        type: '',
        action: '',
        storage: '',
        tokenGenerator: '',
        transformer: '',
        transformerSelections: [{ type: '', selector: '' }],
        targets: [''],
        config: {
          condition: '',
          rules: [{ field: '', type: '', operator: '', value: '' }],
        },
      },
    ],
  };
  errors: any = {
    name: '',
    type: '',
    vault: '',
    sourceIp: [],
    destinationDomain: '',
    filters: [
      {
        type: '',
        action: '',
        storage: '',
        tokenGenerator: '',
        transformer: '',
        transformerSelections: [{ type: '', selector: '' }],
        targets: [''],
        config: {
          condition: '',
          rules: [{ field: '', type: '', operator: '', value: '' }],
        },
      },
    ],
  };

  constructor(
    private route: ActivatedRoute,
    private vaultService: VaultService,
    private notification: NzNotificationService,
    private relayService: RelayService,
    private generalService: GeneralService
  ) {
    this.relayId = this.route.snapshot.paramMap.get('id') ?? '';
    this.singleRelay.filters[0].action = this.actionType[1];
    this.singleRelay.filters[0].config.rules[0].field = this.rulesField[1];
    this.singleRelay.filters[0].transformer = this.transformers[0];
  }
  ngOnInit() {
    this.getRelayById();
    this.getVaults();
  }
  addTransformerSelection(filterIndex: number) {
    this.singleRelay?.filters[filterIndex]?.transformerSelections?.push({
      type:
        this.singleRelay?.filters[filterIndex].transformer
          .replace(/Transformer/g, '')
          .trim()
          .toLowerCase() === 'json'
          ? 'JSON'
          : this.singleRelay?.filters[filterIndex].transformer
              .replace(/Transformer/g, '')
              .trim(),
      selector: '',
    });
  }
  addTarget(filterIndex: number) {
    this.singleRelay?.filters[filterIndex]?.targets?.push('');
  }
  addRule(filterIndex: number) {
    this.singleRelay?.filters[filterIndex]?.config?.rules?.push({
      field: this.rulesField[1],
      type: '',
      operator: '',
      value: '',
    });
  }
  addFilter() {
    this.singleRelay.filters.push({
      type: '',
      action: this.actionType[1],
      storage: '',
      tokenGenerator: '',
      transformer: this.transformers[0],
      transformerSelections: [{ type: '', selector: '' }],
      targets: [''],
      config: {
        condition: '',
        rules: [
          { field: this.rulesField[1], type: '', operator: '', value: '' },
        ],
      },
    });
  }
  removeFilter(index: number) {
    if (this.singleRelay.filters.length > 1) {
      this.singleRelay.filters.splice(index, 1);
    }
  }
  removeRule(index: number, filterIndex: number) {
    if (this.singleRelay?.filters[filterIndex]?.config?.rules.length > 1) {
      this.singleRelay?.filters[filterIndex]?.config?.rules.splice(index, 1);
    }
  }
  removeTarget(index: number, filterIndex: number) {
    if (this.singleRelay?.filters[filterIndex]?.targets.length > 1) {
      this.singleRelay?.filters[filterIndex]?.targets.splice(index, 1);
    }
  }
  removeTransformerSelection(index: number, filterIndex: number) {
    if (
      this.singleRelay?.filters[filterIndex]?.transformerSelections.length > 1
    ) {
      this.singleRelay?.filters[filterIndex]?.transformerSelections.splice(
        index,
        1
      );
    }
  }
  separateByComma(input: string): string[] {
    return input.split(',').map((item) => item.trim());
  }
  setIpAddresses = (values: any) => {
    this.singleRelay.sourceIp = this.separateByComma(values);
  };
  // setApiKey(data: string) {
  //   this.apiKey = data;
  // }
  handleInput(data: { title: string; value: string }) {
    if (data.title === 'vault') {
      this.singleRelay[data.title] = this.getVaultId(data.value);
    } else {
      this.singleRelay[data.title] = data.value;
    }
    if (data.value === '') {
      // this.errors[data.title] = 'Required*';
      return;
    } else {
      // this.errors[data.title] = '';
    }
  }
  trackByFn(index: number, item: any) {
    return index;
  }
  handleTarget(
    data: { title: string; value: string },
    filterIndex: number,
    targetIndex: number
  ) {
    this.singleRelay.filters[filterIndex].targets[targetIndex] = data.value;
    if (data.value === '') {
      // this.errors[data.title] = 'Required*';
      return;
    } else {
      // this.errors[data.title] = '';
    }
  }
  handleRules(
    data: { title: string; value: string },
    filterIndex: number,
    ruleIndex: number
  ) {
    if (data.value === 'HTTPMethod') {
      this.selectedRuleDropdown = this.httpMethodData;
    }
    if (data.value === 'ContentType') {
      this.selectedRuleDropdown = this.contentTypeData;
    }
    this.singleRelay.filters[filterIndex].config.rules[ruleIndex][data.title] =
      data.value;
    if (data.value === '') {
      // this.errors[data.title][ruleIndex] = 'Required*';
      return;
    } else {
      // this.errors[data.title][ruleIndex] = '';
    }
  }
  handleConfig(data: { title: string; value: string }, filterIndex: number) {
    this.singleRelay.filters[filterIndex].config.condition = data.value;
    if (data.value === '') {
      // this.errors[data.title] = 'Required*';
      return;
    } else {
      // this.errors[data.title] = '';
    }
  }
  handleTransformerType(
    data: { title: string; value: string },
    filterIndex: number
  ) {
    if (data.value in this.fieldPlaceholders) {
      this.selectedFieldPraceholder = this.fieldPlaceholders[data.value];
    }
    this.singleRelay.filters[
      filterIndex
    ].transformer = `${data.value}Transformer`;
    this.singleRelay.filters[filterIndex].transformerSelections.forEach(
      (selection: any) => {
        selection.type = data.value.toUpperCase();
      }
    );
    if (data.value === '') {
      // this.errors[data.title] = 'Required*';
      return;
    } else {
      // this.errors[data.title] = '';
    }
  }
  removeTransformer(input: string): string {
    const result = input.replace(/Transformer/g, '').trim();
    return result.charAt(0).toUpperCase() + result.slice(1);
  }

  handleTransformerSelections(
    data: { title: string; value: string },
    filterIndex: number,
    transformerIndex: number
  ) {
    this.singleRelay.filters[filterIndex].transformerSelections[
      transformerIndex
    ][data.title] = data.value;
    if (data.value === '') {
      // this.errors[data.title][transformerIndex] = 'Required*';
      return;
    } else {
      // this.errors[data.title][transformerIndex] = '';
    }
  }
  handleBaseFilterData(
    data: { title: string; value: string },
    filterindex: number
  ) {
    this.singleRelay.filters[filterindex][data.title] = data.value;
    if (data.value === '') {
      // this.errors[data.title] = 'Required*';
      return;
    } else {
      // this.errors[data.title] = '';
    }
  }
  getVaults() {
    this.fetchingData = true;
    this.vaultService.getVaults().subscribe({
      next: (res: any) => {
        this.fetchingData = false;
        this.vaults = res.data;
        console.log(this.vaults);
        this.vaultNames = this.vaults.map((vault: { name: any }) => vault.name);
      },
      error: () => {
        this.fetchingData = false;
        this.notification.error('Error', 'Failed to fetch vault data', {
          nzClass: 'notification',
        });
      },
    });
  }
  getVaultId(name: string) {
    const vault = this.vaults.find(
      (vault: { name: string }) => vault.name === name
    );
    return vault ? vault._id : null;
  }
  getVaultName(id: string) {
    if (this.vaults) {
      const vault = this.vaults.find(
        (vault: { _id: string }) => vault._id === id
      );
      return vault ? vault?.name : null;
    }
  }
  // validateRelay() {
  //   this.errors = this.deepClone(this.newRelay); // Ensure a deep copy

  //   // Validate top-level properties
  //   Object.keys(this.newRelay).forEach((key) => {
  //     if (Array.isArray(this.newRelay[key])) {
  //       if (!this.newRelay[key]?.length) {
  //         this.errors[key] = 'Required';
  //       } else {
  //         this.errors[key] = this.newRelay[key].map(
  //           (item: any, index: number) => {
  //             if (typeof item === 'object') {
  //               return this.validateObject(item); // Validate nested objects
  //             }
  //             return item ? '' : 'Required';
  //           }
  //         );
  //       }
  //     } else {
  //       this.errors[key] = this.newRelay[key] ? '' : 'Required';
  //     }
  //   });

  //   console.log(this.errors);
  // }

  // validateObject(obj: any) {
  //   const errorObj: any = {};
  //   Object.keys(obj).forEach((key) => {
  //     if (Array.isArray(obj[key])) {
  //       errorObj[key] =
  //         obj[key]?.map((item: any) => {
  //           if (typeof item === 'object') {
  //             return this.validateObject(item);
  //           }
  //           return item ? '' : 'Required';
  //         }) || [];
  //     } else {
  //       errorObj[key] = obj[key] ? '' : 'Required';
  //     }
  //   });
  //   return errorObj;
  // }

  // deepClone(obj: any) {
  //   return JSON.parse(JSON.stringify(obj));
  // }
  validateFields(obj: any): boolean {
    const isEmpty = (value: any): boolean => {
      return (
        value === '' ||
        value === null ||
        value === undefined ||
        (Array.isArray(value) && value.length === 0)
      );
    };

    const checkObject = (obj: any): boolean => {
      for (const key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) {
          const value = obj[key];

          if (typeof value === 'object' && value !== null) {
            if (Array.isArray(value)) {
              if (
                value.length === 0 ||
                value.some(
                  (item) =>
                    isEmpty(item) ||
                    (typeof item === 'object' && !checkObject(item))
                )
              ) {
                return false;
              }
            } else {
              if (!checkObject(value)) {
                return false;
              }
            }
          } else {
            if (isEmpty(value)) {
              return false;
            }
          }
        }
      }
      return true;
    };

    return checkObject(obj);
  }

  updateRelay = () => {
    console.log(this.singleRelay);
    if (!this.validateFields(this.singleRelay)) {
      this.notification.warning('Please Fill All Fields', '', {
        nzClass: 'notification',
      });
      return;
    }
    this.loading = true;
    this.relayService.updateRelay(this.relayId, this.singleRelay).subscribe(
      (res: any) => {
        this.notification.success('Success', 'Relay Updated', {
          nzClass: 'notification',
        });
        this.loading = false;
        this.generalService.routeTo('relay');
      },
      (error: any) => {
        console.log(error);
        this.loading = false;
        this.notification.error('Error', 'Failed to Update Relay', {
          nzClass: 'notification',
        });
      }
    );
  };
  removeIdFields(obj: any): any {
    if (Array.isArray(obj)) {
      return obj.map((item) => this.removeIdFields(item));
    } else if (typeof obj === 'object' && obj !== null) {
      const newObj: any = { ...obj };
      delete newObj._id;
      Object.keys(newObj).forEach((key) => {
        newObj[key] = this.removeIdFields(newObj[key]);
      });

      return newObj;
    }
    return obj;
  }
  getRelayById() {
    this.pageLoader = true;
    this.relayService.getRelayById(this.relayId).subscribe({
      next: (res: any) => {
        this.pageLoader = false;
        this.singleRelay = this.removeIdFields(res.data);
        delete this.singleRelay._id;
        delete this.singleRelay.vaultKey;
        delete this.singleRelay.organization;
        delete this.singleRelay.isDeleted;
        delete this.singleRelay.__v;
        delete this.singleRelay.vaultId;
        console.log(this.singleRelay);
      },
      error: () => {
        this.pageLoader = false;
        this.notification.error('Error', 'Failed to fetch relay', {
          nzClass: 'notification',
        });
      },
    });
  }
}
